import { Box, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import { shallowEqual, useAppSelector } from 'store'

type InfoRowPropsType = {
  label: string
  value: React.ReactNode
  labelColor?: string
}

const InfoRow = ({ label, value, labelColor = '#646464' }: InfoRowPropsType) => (
  <Box display="flex" justifyContent="space-between" gap="32px">
    <Typography variant="body-small" whiteSpace="nowrap" color={labelColor}>
      {label}
    </Typography>
    <Typography
      variant={value ? 'headline-small' : 'body-small'}
      color={value ? theme.palette.textColor.primaryDark : labelColor}
      textAlign="right"
    >
      {value || '-'}
    </Typography>
  </Box>
)

const RightPanel = () => {
  const data = useAppSelector((state) => state.outboundSOAddEdit.data, shallowEqual)

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <Box
        width="100%"
        borderRadius="8px"
        border="1px solid"
        borderColor={theme.colors.border}
        backgroundColor={theme.colors.white}
        padding="24px"
      >
        <Box display="flex" flexDirection="column" gap="32px">
          <Typography variant="display-tiny">Rangkuman Produk</Typography>

          <Box display="flex" flexDirection="column" gap="16px">
            <InfoRow label="Total SKU" value={data?.supplyOrderProductSummary.totalSku} />
            <InfoRow label="Jumlah Kuantiti" value={data?.supplyOrderProductSummary.totalQty} />
            <InfoRow label="Net Weight" value={data?.supplyOrderProductSummary.netWeight} />
            <InfoRow label="Gross Weight" value={data?.supplyOrderProductSummary.grossWeight} />
            <InfoRow label="Volume Weight" value={data?.supplyOrderProductSummary.volumeWeight} />
            <InfoRow label="Volume" value={data?.supplyOrderProductSummary.volume} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RightPanel
